import { Props } from './types'
import Core from './Core'
import List from './Selection/List'
import { sortUnits } from '../../../../../utility'

const OrganizationUnitSelection: React.FC<Props<any, string>> = ({ survey, element, answer, updateElement }) => {
  return (
    <div>
      <Core element={element} />
      <div className="flex flex-row gap-2 justify-center mt-5">
        <List
          options={survey.context.organizationUnitList.sort(sortUnits).map((unit) => ({
            uuid: unit.uuid,
            value: unit.name,
            selected: answer.organizationUnitUUID === unit.uuid,
          }))}
          toggle={(uuid) => () => updateElement(uuid)}
        />
      </div>
    </div>
  )
}

export default OrganizationUnitSelection
